import {createContext} from "react";

export const MissionListContext = createContext({
    missionList: null,
    selectedMission: null,
    openDeleteMissionModal: false,
    openValidModificationToast: false,
    loading: true,
    history: {},
    location: {},
    setSelectedMission: () => {},
    setOpenDeleteMissionModal: () => {},
    setOpenValidModificationToast: () => {},
    setLoading: () => {},
    handleOpenDeleteMissionModal: () => {},
})